import { render, staticRenderFns } from "./navigation-mobile.vue?vue&type=template&id=0c5685ac&scoped=true"
import script from "./navigation-mobile.vue?vue&type=script&lang=js"
export * from "./navigation-mobile.vue?vue&type=script&lang=js"
import style0 from "./navigation-mobile.vue?vue&type=style&index=0&id=0c5685ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5685ac",
  null
  
)

export default component.exports